import { Page } from "@/components/article-availability/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/article")({
  component: Page,
});
